









import {Vue, Component, Prop} from 'vue-property-decorator';
import PageTabMenu from '@/components/admin/common/PageTabMenu.vue';
@Component({
   components: {
    PageTabMenu
  }
})
export default class AdminTab extends Vue {
  @Prop({required: true}) private type!: string;
}
